import DraftInvoiceItemsList from "./DraftInvoiceItemsList";

export default {
    list: DraftInvoiceItemsList
};
